module.exports = __webpack_public_path__ + "static/media/eksperience.b1cb8661.png";